import { Injectable } from '@angular/core';
import moment from 'moment';

export enum Period {
  all = 'all',
  last7days = 'last7days',
  currentMonth = 'currentMonth',
  currentYear = 'currentYear',
  lastYear = 'lastYear',
  lastMonth = 'lastMonth',
  custom = 'custom',
}

@Injectable({
  providedIn: 'root',
})
export class DateService {
  getDateRange(period: Period): { startDate: Date; endDate: Date } {
    const now = moment();

    const periodMap: Record<Period, () => { startDate: Date; endDate: Date }> = {
      all: () => null,
      last7days: () => ({
        startDate: now.clone().subtract(7, 'days').toDate(),
        endDate: now.toDate(),
      }),
      currentMonth: () => ({
        startDate: now.clone().startOf('month').toDate(),
        endDate: now.clone().endOf('month').toDate(),
      }),
      currentYear: () => ({
        startDate: now.clone().startOf('year').toDate(),
        endDate: now.clone().endOf('year').toDate(),
      }),
      lastYear: () => ({
        startDate: now.clone().subtract(1, 'year').startOf('year').toDate(),
        endDate: now.clone().subtract(1, 'year').endOf('year').toDate(),
      }),
      lastMonth: () => ({
        startDate: now.clone().subtract(1, 'month').startOf('month').toDate(),
        endDate: now.clone().subtract(1, 'month').endOf('month').toDate(),
      }),
      // For the 'custom' period, return null because it is handled separately (user specifies custom range).
      custom: () => null,
    };

    return periodMap[period]?.() || null;
  }

  getAvailablePeriods(): { key: Period; value: string }[] {
    return [
      { key: Period.all, value: 'cipoFields.all' },
      { key: Period.last7days, value: 'SEARCH_AI.FILTER.LAST7DAYS' },
      { key: Period.currentMonth, value: 'SEARCH_AI.FILTER.CURRENT_MONTH' },
      { key: Period.currentYear, value: 'SEARCH_AI.FILTER.CURRENT_YEAR' },
      { key: Period.lastYear, value: 'SEARCH_AI.FILTER.LAST_YEAR' },
      { key: Period.lastMonth, value: 'SEARCH_AI.FILTER.LAST_MONTH' },
      { key: Period.custom, value: 'SEARCH_AI.FILTER.CUSTOM' },
    ];
  }
}
